import {AbsoluteCenter, Box, VStack} from '@chakra-ui/react'
import React from 'react'
import {useNavigate} from 'react-router-dom'
import BackgroundImage from '../../assets/images/meet-up-btn-bkgd.png'
import {BlueButton} from '../button'
import {TextG10, TextG12, TextG18} from '../typography'

const MeetUpButton = () => {
  const navigate = useNavigate()

  return (
    <Box
      mb="15px"
      onClick={() => navigate('/create-meetup')}
      textAlign="center"
      minH="145px"
      backgroundRepeat="round"
      backgroundSize="contain"
      backgroundImage={BackgroundImage}>
      <VStack py="20px" px="30px">
        {/* <TextG10 color="white">On Walkabout, you've always got plans!</TextG10> */}
        <TextG18 lineHeight="normal" color="white" fontWeight="700">
          Join a member meet-up below or create your own
        </TextG18>
        <BlueButton w="fit-content" mt="20px !important">
          <TextG12 fontWeight="500" color="white">
            Create a Member Meet-Up
          </TextG12>
        </BlueButton>
      </VStack>
    </Box>
  )
}

export default MeetUpButton
